import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { getBlogList } from "../../redux/slices/common";
import Organization from "../all-services/organization";
import Skeleton from "@mui/material/Skeleton";

const NewsBlogs = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [centerIndex, setCenterIndex] = useState(1);

  const [blogList, setBlogList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getBlogListSuccessRes } = useSelector((state) => state.common);

  useEffect(() => {
    setLoading(true)
    dispatch(getBlogList());
  }, []);

  useEffect(() => {
    if (getBlogListSuccessRes && getBlogListSuccessRes !== undefined) {
      setLoading(false)
      setBlogList(getBlogListSuccessRes?.blogs);
    }
  }, [getBlogListSuccessRes]);



  const handleHover = (index) => {
    setCenterIndex(index);
  };

  const handleMouseLeave = () => {
    setCenterIndex(1);
  };


  return (
    <section
      className="section-bg layout-pb-md md:pt-40 md:pb-40 "
      data-aos="fade-up">
      <div
        // className="news-Blogs-section d-flex justify-between items-center"
        onMouseLeave={handleMouseLeave}
      >
        <div className="row">
          {loading || !blogList.length
            ? [...Array(3)].map((_, index) => (
              <div key={index} className="col-sm-12 col-md-4 my-3">
                <Skeleton variant="rectangular" width="100%" height={200} />
              </div>
            ))
            : blogList.slice(0, 3).map((blog, index) => (
              <div key={blog._id} className="col-sm-12 col-md-4 my-2" style={{ borderRadius: '8px' }}>
                <div
                  className={`img-1 blog-res ${centerIndex === index ? "center-img" : "opacity-065"}`}
                  onMouseEnter={() => handleHover(index)}
                  onClick={() => router.push(`/blog/blog-details/${blog._id}`)}
                  style={{
                    borderRadius: "6px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={`${process.env.IMAGE_BASE_URL}/${blog.image}`}
                    alt="blog"
                    className="news-img-1"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default NewsBlogs;
